import { render, staticRenderFns } from "./edit-rule.vue?vue&type=template&id=cb23b40c&scoped=true&"
import script from "./edit-rule.vue?vue&type=script&lang=ts&"
export * from "./edit-rule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb23b40c",
  null
  
)

export default component.exports